// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1xaOl","modalFooterButton":"ModalNotes_modalFooterButton__2PSne"};